import axios from 'axios';
import ApiGet from '../../sections/mainheader/apiget';


class RetailerWiseProductWiseSchemeService {

    constructor(apiUrl) {

        this.GetApiUrl = apiUrl;

        this.StatusOfRetailerProductWiseScheme = (payload) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/StatusOfRetailerProductWiseScheme`, { ...payload, showAllSchemes: true }));
        this.GetRetailerWiseProductWiseSchemeSearchControls = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductWiseSchemeSearchControls`));
        this.GetRetailerWiseProductWiseSchemeReportSearchControls = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductWiseSchemeReportSearchControls`));
        this.GetRetailerProductCriteriaControl = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductCriteriaControl`));

        this.GetRetailerSlabMandatoryData = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerSlabMandatoryData`));
        this.RetailerProductWiseDiscount = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerFilterReward/RetailerProductWiseDiscount`));
        this.RetailerProductWiseFreeItem = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerFilterReward/FreeItem`));
        this.RetailerProductWiseGift = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerFilterReward/Gift`));

        this.GetRetailerProductClassificationControl = (payload) =>
            axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductClassificationControl/Item`);

        this.GetRetailerTargetClassificationControl = () =>
            axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerTargetClassificationControl/Item`);



        this.GetRetailerProductClassificationValueControl = (payload) => {
            const areaIds = Array.isArray(payload?.AreaIds)
                ? payload.AreaIds.join(',')
                : (payload?.AreaIds || payload?.AreaId || '');
            const areaParam = areaIds ? `&AreaIds=${encodeURIComponent(areaIds)}` : '';
            return axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductClassificationValueControl?TargetOn=Item&SchemeTargetClassification=${payload.SchemeTargetClassification}${areaParam}`);
        };

        this.GetRetailerProductClassificationValueControl_Retailer = (payload) => {
            const areaIds = Array.isArray(payload?.AreaIds)
                ? payload.AreaIds.join(',')
                : (payload?.AreaIds || payload?.AreaId || '');
            const areaParam = areaIds ? `&AreaIds=${encodeURIComponent(areaIds)}` : '';
            return axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductClassificationValueControl?TargetOn=Retailer&SchemeTargetClassification=${payload.SchemeTargetClassification}${areaParam}`);
        };







        this.GetRetailerTargetClassificationValueControl = (payload) => {
            const areaIds = Array.isArray(payload?.AreaIds)
                ? payload.AreaIds.join(',')
                : (payload?.AreaIds || payload?.AreaId || '');
            const areaParam = areaIds ? `&AreaIds=${encodeURIComponent(areaIds)}` : '';
            return axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerTargetClassificationValueControl?TargetOn=Item&SchemeTargetClassification=${payload.SchemeTargetClassification}${areaParam}`);
        };


        this.DeleteRetailerProductWiseScheme = (id) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/DeleteRetailerProductWiseScheme/${id}`));
        this.RetailerProductSchemeApprovalRejection = (payload) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/RetailerProductSchemeApprovalRejection`, payload));
        this.GetRetailerProductSchemeClaimReport = (payload) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductSchemeClaimReport`, payload));
        this.GetDetailsById = (id) => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetDetailsById`, { params: { Id: id } }));
        this.AddRetailerProductScheme = (payload) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/AddRetailerProductScheme`, payload));
        this.GetSchemesByDateRange = (payload) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/GetSchemesByDateRange`, payload));
        this.UpdateDetailsForRetailerProductScheme = (payload) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/UpdateDetailsForRetailerProductScheme`, payload));

        this.GetRuleBasedSchemeDataById = (schemeId) => axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRuleBasedSchemeDataById`, { params : { SchemeId: schemeId }});
        this.GetRetailerProductSchemeApprovalHistory = (schemeId) => axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductSchemeApprovalHistory`,  { SchemeId: schemeId  });
        
        this.getSchemesByGroupId = (groupId, isRegeneration = false, isReport = false, isSchemeReport = false, isPreProcess = false) => {
            const url = this.GetApiUrl.replace('/api/', '/api');
            return axios.get(`${url}/ApprovalProcess/getSchemesByGroupId/${groupId}`, {
                params: {
                    isRegeneration,
                    isReport,
                    isSchemeReport,
                    isPreProcess
                }
            });
        };

        this.SearchFilter = (payload) => (axios.post(`${this.GetApiUrl}Scheme/SearchSchemeFilter`, payload));
        this.DeleteRetailerProductSchemeGroup = (id) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/DeleteRetailerProductSchemeGroup/${id}`));
        this.GetPreProcessRPWSSchemeGroup = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetPreProcessRPWSSchemeGroup`));

        this.getSchemesByGroupId = async (schemeGroupId, isRegeneration = false, isReport = false, isSchemeReport = false, isPreProcess = false) => {
            try {

                const response = await axios.get(`${this.GetApiUrl}ApprovalProcess/getSchemesByGroupId/${schemeGroupId}`, {
                    params: { isRegeneration, isReport, isSchemeReport, isPreProcess }
                });
                return response.data;
            } catch (error) {
                console.error('Error fetching schemes by group id:', error);
                throw error;
            }
        };

        this.GetRetailerProductWiseSchemeCopyControls = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductWiseSchemeCopyControls`));
        this.GetRetailerProductSchemeEditability = (payload) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductSchemeEditability`, payload));

    }


}

export default ApiGet().then((apiUrl) => new RetailerWiseProductWiseSchemeService(apiUrl));


